module.exports = __webpack_public_path__ + "img/card@3x.84c6bc15.png";